import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
	headers: {
		"ngrok-skip-browser-warning": "true"
	}
});

export default api;
